module.exports = __webpack_public_path__ + "static/media/sensable_36.ab55ac83.gif";